/*
 * @Author: Michael
 * @Date: 2018-09-18 13:40:48
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-08-18 10:31:13
 * 页面初始化Mixin配置, 包括获取数据以及注册微信API
 */
import { Action, Getter } from 'vuex-class';
import { Vue, Component } from 'vue-property-decorator';
import store from '@/store';

import fetch from '@/common/api/fetch';
import { AxiosPromiseData } from '@/common/interface';
import getActivityType from '@/common/utils/getActivityType';
import getUrlParam from '@/common/utils/getUrlParam';
import LazyImage from '@/common/lazyImage';

import getEditDetail from '@/mixins/getEditDetail';
import getMetarialData from '@/mixins/getMetarialData';
import getSMSData from '@/mixins/getSMSData';
import getOpenId from '@/mixins/getOpenId';
import getActivityDetail from '@/mixins/getActivityDetail';
import getViewerDetail from '@/mixins/getViewerDetail';

@Component
export default class PageInitialMixin extends Vue {
  @Getter('openId') openId!: string;

  @Action('getConifgState') getConifgState!: Function;
  @Action('changeXcxFlag') changeXcxFlag!: Function;
  @Action('changeIsInvalid') changeIsInvalid!: Function;
  @Action('changeUrlUid') changeUrlUid!: Function;
  @Action('changeChanceCount') changeChanceCount!: Function;
  @Action('changeBuyXmMajordomo') changeBuyXmMajordomo!: Function;
  @Action('changeOriginalTitle') changeOriginalTitle!: Function;
  @Action('changeWechatMiniOnlineStatus') changeWechatMiniOnlineStatus!: Function;
  @Action('changeXmPayRegisterStatusEnum') changeXmPayRegisterStatusEnum!: Function;
  instId: string = getUrlParam('instId') as string;

  mounted() {
    console.log(process.env.NODE_ENV);
    if (getUrlParam('type') === 'demo' || getUrlParam('type') === 'share') {
      !window.initUrl && (window.initUrl = window.location.href);
      // 由于项目是单页应用，获取微信signature的时候必须记住先前的页面地址，否则获取的signature会是错误的。
      // 因为微信会以页面刚打开时的地址链接来获取signature
      // this.wechatPreviewConfig();
    }
    const adminId = getUrlParam('adminId'); // 如果是小程序，进行标记
    if (adminId) {
      this.changeXcxFlag();
    }

    if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
      document.addEventListener('WeixinJSBridgeReady', this.ready, false);
    } else {
      this.ready();
    }
    if ((getUrlParam('type') !== 'preview' && getUrlParam('source') !== 'preview') || !store.state.loadedConfig) {
      this.getConfigState();
      this.fetchXMPayType();
    }
    new LazyImage();
  }
  ready() {
    if (window.__wxjs_environment === 'miniprogram') {
      this.changeXcxFlag();
    }
  }

  // 获取配置信息
  getConfigState(): void {
    const id: string = getUrlParam('id') as string;
    let _id = id;
    // 处理问号字符
    if (id.search('%3F') > -1) {
      _id = id.slice(0, id.search('%3F'));
    }
    fetch.post('c/xm/show/template/config', { id: _id }).then(async (res: AxiosPromiseData) => {
      try {
        // 如果地址上有uid，则说明这个活动是被人分享出来的，将这个uid设置到urlUid
        if (getUrlParam('uid') && getUrlParam('type') === 'share') {
          this.changeUrlUid(getUrlParam('uid'));
        }
        console.log('模板-data', JSON.parse(res.data));
        const data = JSON.parse(res.data);
        const { viewBackground, documentTitle, section, activityRule, contactQrcode, ladderGroupList } = data;
        const { inputBackgroundColor, inputFontColor, prizeDesc, prizePic, courseDesc, coursePic, courseName, courseType, originPrice } = section;

        if (!inputBackgroundColor) {
          section.inputBackgroundColor = '#f8f9fc';
        }
        if (!inputFontColor) {
          section.inputFontColor = '#666';
        }

        // 处理活动说明
        if (activityRule) {
          const _activityIntros = [
            {
              type: 'text',
              value: activityRule
            }
          ];
          data.activityIntros = _activityIntros;
        }
        // 处理课程描述-砍价/集赞
        if ((getActivityType() === 'bargainType' || getActivityType() === 'tyType') && (prizeDesc || prizePic)) {
          const _prizeIntros = [];
          if (prizeDesc) {
            _prizeIntros.push({
              type: 'text',
              value: prizeDesc
            });
          }
          if (prizePic) {
            let _list = prizePic.split('@').filter((item: string) => {
              return item;
            });
            for (let i = 0; i < _list.length; i++) {
              _prizeIntros.push({
                type: 'img',
                value: _list[i]
              });
            }
          }
          section.prizeIntros = _prizeIntros;
        }
        // 处理课程描述-群接龙
        if (getActivityType() === 'solitaireType' && (courseDesc || coursePic)) {
          const _courseIntros = [];
          if (courseDesc) {
            _courseIntros.push({
              type: 'text',
              value: courseDesc
            });
          }
          if (coursePic) {
            let _list = coursePic.split('@').filter((item: string) => {
              return item;
            });
            for (let i = 0; i < _list.length; i++) {
              _courseIntros.push({
                type: 'img',
                value: _list[i]
              });
            }
          }
          section.courseIntros = _courseIntros;
        }
        // 团购处理
        if (getActivityType() === 'groupType') {
          if (!courseType) {
            data.section.courseType = 'ONE';
          }
          const _courseIntros = [];
          if (courseDesc) {
            _courseIntros.push({
              type: 'text',
              value: courseDesc
            });
          }
          let imgList = [];
          if (coursePic) {
            imgList = coursePic.split('@').filter((item: string) => {
              return item;
            });
            for (let i = 0; i < imgList.length; i++) {
              _courseIntros.push({
                type: 'img',
                value: imgList[i]
              });
            }
          }
          let _courseGroupList = [
            {
              seqNo: 1,
              courseCover: imgList[0] || '',
              courseName: courseName || '',
              courseIntros: _courseIntros || [],
              originPrice,
              ladderGroupList: ladderGroupList || [
                {
                  groupPrice: 1688,
                  groupSize: 2
                }
              ]
            }
          ];
          section.courseIntros = _courseIntros;
          section.courseGroupList = _courseGroupList;
        }

        window.viewBackground = viewBackground;
        data.section = section;
        const { prizeNumber } = section;
        const payload = { config: data };

        const orgId: string = getUrlParam('orgId') as string;

        // 总部
        if (orgId) {
          payload.config.orgId = orgId;
          if (orgId) {
            const res = await fetch.pureUrl('sales/anon/inst/getInstIdByOrgIdAndInstName', { orgId });
            payload.config.instList = res.result;
            payload.config.instIds = ['0'];
          }
        }
        // 模板类型
        switch (getActivityType()) {
          case 'lessonType': // 微传单
            store.dispatch('changeLeftQuota', 10);
            break;
          case 'bargainType': // 砍价
            store.dispatch('changeLeftQuota', prizeNumber);
            payload.config.bargainParameter = {
              prizeNum: prizeNumber,
              prizeLeftCount: prizeNumber,
              minPrice: 888,
              maxPrice: 1800,
              minCutPrice: 23,
              maxCutPrice: 68,
              intervalTime: 2
            };
            break;
          case 'tyType': // 集赞
            payload.config.tyTypeParameter = {
              intervalTime: 2, // 砍价时间间隔 单位分钟
              prizeNum: prizeNumber, // 奖品数量
              prizeLeftCount: prizeNumber, // 奖品剩余数量
              unitNum: 50, // 单位兑奖数量
              goodValue: 16, // 好东西数量
              normalValue: 8, // 普通东西数量
              badValue: 4 // 坏东西数量
            };
            store.dispatch('changeLeftQuota', prizeNumber);
            break;
          case 'gachaType': /// 扭蛋机
            data.prize.addNum = 1;
            payload.config.gachaTypeParameter = {
              playType: 'scholarship', // 玩法说明
              buttonSet: data.buttonSet,
              gachaType: data.gachaType,
              scholarship: data.scholarship,
              prize: data.prize,
              dayTimesChecked: true,
              totalTimesChecked: false,
              mainTextColor: '',
              modalSection: data.modalSection
            };
            break;
          default:
            break;
        }

        // 分销
        if (getActivityType() === 'distributeType') {
          // 分销模板是支付模板
          store.dispatch('switchCanPay', { status: true });
          const { section } = data;
          let { courseDesc } = section;
          payload.config.distributeTypeParameter = {
            distributeMode: 'ANY_TIME',
            courseDesc: [
              {
                type: 'text',
                value: courseDesc
              }
            ]
          };
          if (getUrlParam('broadcastId') && getUrlParam('type') === 'share') {
            store.dispatch('changeSectionInfo', { type: 'detailLoading', value: false });
          } else {
            store.dispatch('changeSectionInfo', { type: 'detailLoading', value: true });
          }
          store.dispatch('changePayNumber', { number: 0 });
          store.dispatch('changeLeftQuota', 100);
        }
        payload.config.loadedConfig = true; // 确保在预览和编辑切换途中刷新还是有数据
        this.getConifgState(payload); // 将配置信息同步到vuex是state里面
        this.changeOriginalTitle(documentTitle);
      } catch (error) {
        Vue.$toast.error('获取配置信息失败', 20000);
      }

      // 获取活动详情, 分享界面
      if (getUrlParam('broadcastId') && getUrlParam('type') === 'share') {
        const xcxFlag = window.__wxjs_environment === 'miniprogram';
        if (this.openId) {
          getActivityDetail(xcxFlag); // 获取活动数据
          if (getActivityType() === 'poseType') {
            getViewerDetail();
          }
        } else {
          await getOpenId();
          if (getActivityType() === 'poseType') {
            getViewerDetail();
          }
          getActivityDetail(xcxFlag); // 获取活动数据
        }
        this.increReferralView();
      }

      // 编辑界面或者预览页面(保存未发布)
      if (getUrlParam('type') === 'edit' || getUrlParam('type') == 'reEdit' || getUrlParam('type') === 'check') {
        getEditDetail();
      }

      if (getUrlParam('type') === 'edit' && !getUrlParam('adminId') && getUrlParam('instId') && !getUrlParam('broadcastId')) {
        !window.location.href.includes('orgId') && this.checkXmMajordomo();
      }
      if ((getUrlParam('type') === 'edit' || getUrlParam('type') === 'reEdit') && getUrlParam('instId') && !getUrlParam('adminId')) {
        // 获取素材库材料
        !window.location.href.includes('orgId') && getMetarialData();
        getSMSData();
      }
    });
    if (getUrlParam('type') === 'edit' && getActivityType() === 'tyType') {
      this.changeChanceCount({ chance: 57, count: 5 });
    }
  }

  // 获取小麦收银和微信认证状态
  fetchXMPayType = () => {
    if (this.instId && this.instId !== 'undefined') {
      fetch.Finance('anon/xmPay/getInstChannelStatus', { instId: this.instId }).then((res: any) => {
        const { wechatMiniOnlineStatus, xmPayRegisterStatusEnum } = res.result;
        this.changeWechatMiniOnlineStatus(wechatMiniOnlineStatus);
        this.changeXmPayRegisterStatusEnum(xmPayRegisterStatusEnum);
      });
    }

  };
  // 检验是否购买了小麦管家
  checkXmMajordomo() {
    const param = {
      instId: getUrlParam('instId')
    };
    fetch.post('c/xm/show/checkXmMajordomo', param).then((res: AxiosPromiseData) => {
      this.changeBuyXmMajordomo(res.data);
    });
  }

  // 转介绍活动增加预览次数
  increReferralView() {
    const promoterId: string = getUrlParam('promoterId') as string;
    const referralId: string = getUrlParam('referralId') as string;

    if (promoterId) {
      const param = {
        promoterId,
        referralId
      };
      fetch.post('c/xm/show/incReferralView', param);
    }
  }
}
